<template>
    <v-card>
        <v-card-title>
          <h2 class="headline">{{ qid(currentQuestion).question }}</h2>
        </v-card-title>
        <v-divider>
        </v-divider>
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex v-bind:key="answer.id" v-for="answer in qid(currentQuestion).answers" xs12 sm4 lg4 xl2>
            <v-card v-bind:class="isSelected(currentQuestion, answer.id)" @click.native="selectAnswer(currentQuestion, answer.id)" tile hover>
                <v-img :src="'img/questions/'+ qid(currentQuestion).id + '/' + answer.image_name" :height="determineHeight(qid(currentQuestion), answer)"/>
                <v-card-title v-if="qid(currentQuestion).id === 8" class="subheading">
                  {{answer.text}}
                </v-card-title>
            </v-card>
            </v-flex>
          </v-layout>
        </v-container>
    </v-card>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "MetsankayttajaImage",
  computed: {
    ...mapState("metsankayttaja", ["currentAnswers", "currentQuestion", 'answers']),
    ...mapGetters("metsankayttaja", ["qid"])
  },
  data: function() {
    return {
      determineHeight(q) {
        if (q.id === 8) return "400px";
        return "300px";
      },
      selectAnswer(q, a) {
        this.$store.dispatch("metsankayttaja/addAnswer", {
          question: q,
          answer: a
        });
      },
    };
  },
  methods: {
    isSelected(question, answer) {
      if(this.answers[question] === answer) {
        return ['selected-answer']
      } else if(this.answers[question] === undefined) {
        return ['']
      } else {
        return ['unselected']
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.align-slider-text {
  float: right;
  margin-right: 15px;
}

.unselected {
  opacity: 0.2;
}

.bgwhite {
  background: white;
}
</style>
